import axios from 'axios';

// API Base URL konfigurieren - immer HTTPS verwenden
let API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de';

// Stelle sicher, dass die API_BASE_URL immer HTTPS verwendet
if (API_BASE_URL.startsWith('http://')) {
  API_BASE_URL = API_BASE_URL.replace('http://', 'https://');
}

axios.defaults.baseURL = API_BASE_URL;

// Debug-Logging für API-URLs
console.log('API Base URL:', API_BASE_URL);

// Axios Interceptor für Authentifizierung und HTTPS-Erzwingung
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Stelle sicher, dass alle URLs HTTPS verwenden
    if (config.url && config.url.startsWith('http://')) {
      config.url = config.url.replace('http://', 'https://');
    }
    
    // Stelle sicher, dass die baseURL auch HTTPS verwendet
    if (config.baseURL && config.baseURL.startsWith('http://')) {
      config.baseURL = config.baseURL.replace('http://', 'https://');
    }
    
    // Stelle sicher, dass die vollständige URL HTTPS verwendet
    if (config.url && !config.url.startsWith('http')) {
      // Relative URL - baseURL sollte bereits HTTPS sein
      const fullUrl = config.baseURL + config.url;
      if (fullUrl.startsWith('http://')) {
        config.url = fullUrl.replace('http://', 'https://');
        config.baseURL = '';
      }
    } else if (config.url && config.url.startsWith('http://')) {
      // Absolute URL - direkt HTTPS erzwingen
      config.url = config.url.replace('http://', 'https://');
    }
    
    // Debug-Logging für axios-Requests
    console.log('Axios Request URL:', config.url);
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Axios Interceptor für Fehlerbehandlung
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Nur zur Login-Seite weiterleiten, wenn wir nicht bereits dort sind
      // Und nicht bei Chat-Session-Routen
      const isChatSession = window.location.pathname.startsWith('/chat/session/') || 
                           window.location.pathname.startsWith('/chat-session/') ||
                           window.location.pathname.startsWith('/chat/widget/');
      
      if (window.location.pathname !== '/login' && 
          window.location.pathname !== '/' && 
          !isChatSession) {
        console.log('Redirecting to login due to 401/403 error');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
